
      window.AppVersion = APP_VERSION
    